module.exports = __webpack_public_path__ + "open-sans-v17-latin-600.woff?449d681cd6006390e1bee3c3a660430b";